const TEXTS_WITH_MAX_RESOLUTION_LIMIT = 100

const getResolution = (scale) => {
  if (scale >= 0.5) {
    return 1
  } else if (scale >= 0.25) {
    return 0.5
  } else if (scale >= 0.125) {
    return 0.25
  } else if (scale >= 0.0625) {
    return 0.125
  }
  return 0.0625
}

export const applyTextResolution = (texts, scale, changeLimit) => {
  let changed = 0
  let remained = 0
  let resolution = getResolution(scale)
  if (window.devicePixelRatio > 1) {
    resolution *= 2
  }
  const degradeToResolution = Math.min(1, resolution)

  for (let i = 0, visibleCounter = 0; i < texts.length; i++) {
    if (texts[i].worldVisible === false) {
      continue
    }

    visibleCounter++
    if (visibleCounter > TEXTS_WITH_MAX_RESOLUTION_LIMIT) {
      resolution = degradeToResolution
    }

    if (texts[i].resolution === resolution) {
      continue
    }

    if (changed >= changeLimit) {
      remained++
      continue
    }

    texts[i].resolution = resolution
    changed++
  }

  return {
    changed,
    remained,
  }
}
